<div class="PGRoleViewSimpleCard" #simpleCard>
    <div class="PGRoleViewSimpleCard-Content">
        @if (isLoading) {
            <app-pg-loading></app-pg-loading>
        }
        @if (!isLoading) {
            <div class="PGRoleViewSimpleCard-Content-Text">
                <div class="PGRoleViewSimpleCard-Content-Text-Title">{{roles.title}}</div>
                @if (roles.abstract != null && roles.abstract != '') {
                    <div class="PGRoleViewSimpleCard-Content-Text-Abstract text-muted">{{roles.abstract}}</div>
                }
            </div>
        }
    </div>
</div>